import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DiscussionContainerComponent } from './discussion-container/discussion-container.component';
import { NewDiscussionComponent } from './new/discussion.new.component';

const routes: Routes = [
  { path: 'new', component: NewDiscussionComponent },
  { path: ':id', component: DiscussionContainerComponent },
  { path: ':id/edit', component: NewDiscussionComponent },
  { path: ':id/:name', component: DiscussionContainerComponent },
  { path: '**', redirectTo: 'new' }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DiscussionRoutingModule {}
